import { Component, Injector, OnInit } from '@angular/core';
import { CustomerBillingOtherCustomerListData } from '../customer-billing-other-customer-list-data';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { CustomerService } from '../../customer-billing-customer/customer.service';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { CoreParameterModel } from '@fi-shared/models';
import { fiCustomerType } from '../../customer-billing-customer/customer-type';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';

@Component({
    selector: 'fi-customer-billing-other-customer-list',
    template: '<fi-items-list [settings]="ListData"></fi-items-list>',
    styleUrls: ['./customer-billing-other-customer-list.component.scss'],
    standalone: false,
})
export class CustomerBillingOtherCustomerListComponent
    extends ItemsListContainerBase<CustomerBillingOtherCustomerListData>
    implements OnInit
{
    constructor(
        private customerService: CustomerService,
        private injector: Injector,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => new CustomerBillingOtherCustomerListData(this.injector), {
            noLocalSearch: true,
            showDelete: false,
        });

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });
    }

    protected LoadItems(): Promise<void> {
        return this.customerService.GetOtherBillingCustomers(this.getSearchParameterModel()).then((response) => {
            this.ListData.appendData(response as any);
            // this.tabsModuleService.updateTabsListData(this.ListData);
        });
    }

    protected SetItemsCount(): IFiHttpPromise<number> {
        return this.customerService.GetOtherBillingCustomersCount(fiCustomerType.Other);
    }

    private getSearchParameterModel() {
        const parameterModel: any = new CoreParameterModel();

        Object.assign(parameterModel, this.ListData.getOffsetParams());

        parameterModel.SelectedSort = {
            ColumnName: this.ListData.Sort.Column,
            SortDirection: this.ListData.Sort.Reverse,
        };

        parameterModel.CustomerType = fiCustomerType.Other;
        parameterModel.Names = [];

        return parameterModel;
    }
}
